import React, { Component, Suspense } from 'react';
import BlockUi from 'react-block-ui';
import { connect } from 'react-redux';
// utils
import { clearPageStateFromSessionStorage, clearPageStateFromSessionStorageLevel2, getStaffConfig, isEmptyObject } from './utils';
// children
import axios from 'axios';
import * as moment from 'moment';
import Notification from './components/common/Notification';
import Footer from './components/layouts/Footer/Footer';
import Header from './components/layouts/Header/Header';
import DarkTitlebar from './components/layouts/darkTitlebar/darkTitlebar';
import { decryptData } from './utils';

//style
import 'react-block-ui/style.css';
import { setConfig } from './actions/actionCreator';
import Routes from './routes';

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      timeoutModel: false,
      staticHeading: false,
      begin: 0
    };
    this.setIntervalFalg = true;
    this.inactivityTimeout = null;
    this.lastActivity = Date.now();
  }
  updateLastActivity = () => {
    this.lastActivity = Date.now();
  };

  setIntervalTime = () => {

    var sessionDate = moment.utc(this.props.cookie !== undefined ? this.props.cookie.cookie : undefined).format("DD/MM/YYYY HH:mm:ss");

    if (sessionDate !== undefined) {
      var end = moment(this.props.cookie.cookie)
      var minutes = end.diff(moment.utc(), 'minutes');

      if (minutes === 4) {
        this.setState({
          timeoutModel: true,
          minutes: minutes
        })
      }
    }

  }

  componentWillMount() {
    this.getConfig()
  }

  getConfig = async () => {
    const config = await getStaffConfig()
    if (!isEmptyObject(config)) {
      this.props.setConfig(config)
    }
  }

  componentDidMount() {
    clearPageStateFromSessionStorage();
    clearPageStateFromSessionStorageLevel2();
    if (window.addEventListener) {
      window.addEventListener('beforeunload', this.onUnload, true);
    } else if (window.attachEvent) {
      window.attachEvent('onbeforeunload', this.onUnload);
    }
    // this.resetInactivityTimer();
    window.addEventListener('mousemove', this.updateLastActivity);
    window.addEventListener('keydown', this.updateLastActivity);
    window.addEventListener('click', this.updateLastActivity);
    window.addEventListener('scroll', this.updateLastActivity);

    this.inactivityCheckInterval = setInterval(() => {
      const now = Date.now();
      if (now - this.lastActivity > 20 * 60000) { // 5 minutes
        this.handleInactivityLogout();
      }
    }, 10000);
  }

  componentDidUpdate() {
    // document.getElementsByClassName("gdoc-table-cell")[0].firstChild.focus();
  }

  onUnload = async () => {
    const tokenFromLS = window.localStorage.getItem("token");
    if (tokenFromLS) {
      try {
        const token = await decryptData(tokenFromLS);
        if (token) {
          const owningCase = window.localStorage.getItem('owningCase');
          const sowId = localStorage.getItem("sowId")
          const customer = window.localStorage.getItem("customer");
          const authOptions = {
            method: 'PUT',
            url: '',
            crossDomain: true,
            dataType: 'json',
            headers: { 'Accept-API-Version': 'protocol=1.0,resource=2.1', [customer && customer.toLowerCase() === "true" ? 'AMToken' : 'x-hsbc-e2e-trust']: token },
            data: { pageUrl: window.location.pathname, event: "Page Refresh" }
          };
          if (owningCase) {
            authOptions.url = "/cases/" + owningCase + "/exitCase"
            await axios(authOptions)
          }
          if (sowId) {
            authOptions.url = "/sows/" + sowId + "/exitSow"
            await axios(authOptions)
          }
          window.localStorage.clear();
        }
      } catch (error) {
        console.log(error)
      }
    }
  }

  componentWillReceiveProps(nextProps) {
    // document.getElementsByClassName("gdoc-table-cell")[0].firstChild.focus();
    if (this.props.cookie && this.props.cookie.cookie !== '' && this.props.cookie.cookie !== undefined && this.props.cookie.cookie !== nextProps.cookie.cookie) {
      clearInterval(this.state.begin);
      let begin = setInterval(this.setIntervalTime, 60 * 1000);
      //this.rotatorId.push(begin);
      this.setState({
        begin: begin,
        staticHeading: true
      })
      this.setIntervalFalg = false
    }
    //  clearInterval(this.interval)
  }

  resetInterval = () => {
    this.setState({
      timeoutModel: false,
      minutes: 0
    })
    clearInterval(this.state.begin);
  }

  stopInterval = () => {
    clearInterval(this.state.begin);
    this.setState({
      timeoutModel: true,
      minutes: 0
    })

  }

  startInterval = () => {
    clearInterval(this.state.begin);
    let begin = setInterval(this.setIntervalTime, 60 * 100);
    this.setState({
      begin: begin,
      timeoutModel: false
    })
  }

  clearInactivityTimer = () => {
    if (this.inactivityTimeout) {
      clearTimeout(this.inactivityTimeout);
      this.inactivityTimeout = null;
    }
  };

  resetInactivityTimer = () => {
    this.clearInactivityTimer();
    // 5 minutes = 300000 ms
    this.inactivityTimeout = setTimeout(this.handleInactivityLogout, 20 * 60000);
  };

  handleInactivityLogout = () => {
    this.setState({
      timeoutModel: true,
    })
  };

  componentWillUnmount() {
    // App Unmounted, performing clean up activities
    // clearing Page State from session storage
    window.sessionStorage.removeItem('previousPageState');
    window.sessionStorage.removeItem('casesForRefresh');
    window.sessionStorage.removeItem("getCurrentDropDown");
    window.removeEventListener('beforeunload', this.onUnload())
    clearInterval(this.state.begin);
    // this.clearInactivityTimer();
    window.removeEventListener('mousemove', this.updateLastActivity);
    window.removeEventListener('keydown', this.updateLastActivity);
    window.removeEventListener('click', this.updateLastActivity);
    window.removeEventListener('scroll', this.updateLastActivity);
    if (this.inactivityCheckInterval) {
      clearInterval(this.inactivityCheckInterval);
    }
  }
  render() {
    const props = this.props;
    return (
      <BlockUi tag="div" blocking={props.blocking} loader={<span style={{ fontSize: "2.25rem" }} role='status'>Loading...</span>} keepInView>
        <div className="app-container">
          <header>
            <Header history={props.history} />
          </header>
          <main>
            <DarkTitlebar history={props.history} staticHeading="true" />
            <div className="container-area">
              <Suspense fallback={<BlockUi tag="div" blocking={true} loader={<span style={{ fontSize: "2.25rem" }} role='status'>Loading...</span>} keepInView></BlockUi>}>
                <Routes config={this.props.config}></Routes>
              </Suspense>
            </div>
            <Notification history={props.history} stopInterval={this.stopInterval}
              timeoutModel={this.state.timeoutModel} minutes={this.state.minutes}
              startInterval={this.startInterval}
              resetInterval={this.resetInterval}
              cookie={this.props.cookie.cookie}
              staticHeading={this.state.staticHeading}
            />
          </main>
          <Footer
            copyright="HSBC Group 2018"
            staticHeading="true"
          />
        </div>
      </BlockUi>
    );
  }


}


const SomethingBroken = (props) => {
  return (
    <div className="broken-page">
      <h1>
        We apologise that the system is currently not available.  Please try again later and advise your HSBC contact if you continue to experience problems.
      </h1>
    </div>
  )
}

class ErrorBoundaryWrapper extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(error, info) {
    this.setState({ hasError: true });
  }

  render() {
    if (this.state.hasError) {
      //UI Fallback
      return <SomethingBroken />;
    }
    return <App {...this.props} />;
  }
}

const mapStateToProps = (state) => {
  let blocking = false;
  if (state.uiBlocker.blockUI !== undefined && state.uiBlocker.blockUI === true) {
    blocking = true;
  } else if (state.uiBlocker.blockUI === undefined) {
    if (state.uiBlocker.requestCounter > 0) {
      blocking = true;
    } else if (state.uiBlocker.requestCounter === 0) {
      blocking = false;
    }
  }
  return {
    blocking,
    cookie: state.cookie,
    auth: state.auth,
    cases: state.cases,
    savedSow: state.savedSow,
    config: state.config
  }
}

const mapDispatchToProps = dispatch => {
  return {
    setConfig: (obj) => {
      dispatch(setConfig(obj))
    }
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(ErrorBoundaryWrapper);


// WEBPACK FOOTER //
// ./src/App.js